<template>
  <div>
    <!-- <template v-if="!userInfo">
      <unlogin />
    </template> -->
    <template>
      <Swiper
        class="home-banner"
        :list="relbanner"
        src-key="imageUrl"
        link-key="jumpUrl"
        :height="isMobile ? '' : 238"
        :borderRadius="isMobile ? 0 : '4px'"
        :interval="5000"
        v-if="relbanner && relbanner.length"
      />
      <!-- 熱評陪玩師 -->
      <section v-show="suggestList.length">
        <div class="title">{{$t('upgrade_page_views_home_index_1')}}</div>
        <div class="custom-swiper">
          <el-carousel
            ref="suggest"
            class="suggest-slide"
            :height="isMobile ? '132px' : '232px'"
            :interval="0"
            trigger="click"
            arrow="never"
            :loop="false"
            indicator-position="none"
            :initial-index="suggestInitial"
            @change="suggestChange"
          >
            <el-carousel-item
              v-for="(list, index) in suggestList"
              :key="index + 'cc'"
              class="suggest-slide-card"
            >
              <suggest-item v-for="item in list" :key="item.id" :item="item" />
            </el-carousel-item>
          </el-carousel>
          <div
            v-show="suggestSlideIndex !== 0"
            class="custom-arrow custom-arrow-left"
            @click="swipeChange('prev', 'suggest')"
          >
            <fps-icon type="arrow-left" size="24" />
          </div>
          <div
            v-show="suggestSlideIndex !== suggestList.length - 1"
            class="custom-arrow custom-arrow-right"
            @click="swipeChange('next', 'suggest')"
          >
            <fps-icon type="arrow-right" size="24" />
          </div>
        </div>
      </section>
      <!-- 熱門技能 -->
      <section>
        <div class="title">{{$t('upgrade_page_views_home_index_2')}}<router-link class="link-more" to="/skill-list"
            >{{$t('upgrade_page_views_home_index_3')}}</router-link
          >
        </div>
        <div class="custom-swiper">
          <el-carousel
            ref="games"
            class="games-slide"
            :height="isMobile ? '112px' : '172px'"
            :interval="0"
            trigger="click"
            arrow="never"
            :loop="false"
            indicator-position="none"
            @change="gameSlideIndex = $event"
          >
            <el-carousel-item
              v-for="(list, index) in allGamesList"
              :key="index + 'pp'"
              class="games-slide-card"
            >
              <div v-for="item in list" :key="item.id">
                <router-link class="cover" :to="`/player-list/${item.id}`">
                  <img :src="item.imageUrl + '?d=300x300'" />
                </router-link>
                <p>{{ item.name }}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div
            v-show="gameSlideIndex !== 0"
            class="custom-arrow custom-arrow-left"
            @click="swipeChange('prev', 'games')"
          >
            <fps-icon type="arrow-left" size="24" />
          </div>
          <div
            v-show="gameSlideIndex !== allGamesList.length - 1"
            class="custom-arrow custom-arrow-right"
            @click="swipeChange('next', 'games')"
          >
            <fps-icon type="arrow-right" size="24" />
          </div>
        </div>
      </section>
      <!-- 推薦遊戲列表 -->
      <transition-group name="fade">
        <section
          v-for="(skillObj, index) in skillList"
          :key="skillObj.id + 'a' + index"
          v-show="skillObj.lists"
        >
          <div class="title">
            {{ skillObj.columnName
            }}<router-link
              class="link-more"
              :to="`/player-list/${skillObj.gameId}`"
              >{{$t('upgrade_page_views_home_index_3')}}</router-link
            >
          </div>
          <div v-if="isMobile" class="skill-panel">
            <template v-for="list in skillObj.lists">
              <div v-for="item in list" :key="item.id">
                <player-item v-if="item.id > 0" :item="item" />
              </div>
            </template>
          </div>
          <div v-else class="custom-swiper">
            <el-carousel
              ref="skill"
              class="skill-slide"
              height="334px"
              :interval="0"
              trigger="click"
              arrow="never"
              :loop="false"
              indicator-position="none"
              @change="skillObj.slideIndex = $event"
            >
              <el-carousel-item
                v-for="(list, index) in skillObj.lists"
                :key="index + 'ee'"
                class="skill-slide-card"
              >
                <div v-for="item in list" :key="item.id">
                  <player-item v-if="item.id > 0" :item="item" />
                </div>
              </el-carousel-item>
            </el-carousel>
            <div
              v-show="skillObj.slideIndex !== 0"
              class="custom-arrow custom-arrow-left"
              @click="swipeChange('prev', 'skill', index)"
            >
              <fps-icon type="arrow-left" size="24" />
            </div>
            <div
              v-show="skillObj.slideIndex !== skillObj.lists.length - 1"
              class="custom-arrow custom-arrow-right"
              @click="swipeChange('next', 'skill', index)"
            >
              <fps-icon type="arrow-right" size="24" />
            </div>
          </div>
        </section>
      </transition-group>
      <div class="bottom-blank"></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swiper from '@/components/Swiper';
import SuggestItem from './suggest-item.vue';
import PlayerItem from '@/upgrade-page/views/player-list/player-item';
// import unlogin from './unlogin'
export default {
  components: {
    Swiper,
    SuggestItem,
    PlayerItem
    // unlogin
  },
  data() {
    return {
      isMobile: window.innerWidth < 600,
      // 頂部 banner
      bannerList: [],
      // 熱評陪玩師
      suggestList: [],
      suggestLoading: false,
      suggestPageIndex: 0,
      suggestSlideIndex: 0,
      suggestInitial: 0,
      suggestIds: [],
      // 熱門技能
      gameSlideIndex: 0,
      // 技能列表（後台配置）
      skillList: [],
      skillListUids: [],
      skillTimeout: 0,
      // 排行榜
      rankListWeek: [],
      rankListTotal: [],
      rankSlideIndex: 0,
      rankType: 'week'
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo', 'allGameCustomList']),
    allGamesList() {
      let list = this.allGameCustomList.reduce((prev, cuur) => {
        const lastItem = prev[prev.length - 1];
        if (prev.length === 0 || (lastItem && lastItem.length === 7)) {
          return [...prev, [cuur]];
        } else {
          lastItem.push(cuur);
          return [...prev];
        }
      }, []);
      if (!list || !list.length) return [];
      const lastIdx = list.length - 1;
      if (list[lastIdx].length < 7) {
        return list.slice(0, lastIdx);
      } else {
        return list;
      }
    },
    rankListActive() {
      return this.rankType == 'total' ? this.rankListTotal : this.rankListWeek;
    },
    // 临时过滤，b端可看问卷调查
    relbanner() {
      const uInfo = this.userInfo || {};
      const qsLink =
        'https://docs.google.com/forms/d/e/1FAIpQLSfSwjjIZEv3mdb3M6WmmTF9G7wvOI3dE6STSWV59sXUCfAMmw/viewform';
      const list = this.bannerList.filter(item => {
        return item.jumpUrl !== qsLink || uInfo.userKind === 'Player';
      });
      list.forEach(item => {
        if(item.jumpUrl === '#') {
          item.jumpUrl = ''
        } else {
         item.jumpUrl = item.jumpUrl +(item.jumpUrl.indexOf('?') > -1 ? '&' : '?') + 'pageFrom=home';
        }
      });
      return list;
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getLoginedData();
      }
    }
  },
  created() {
    this.getLoginedData();
  },
  methods: {
    getLoginedData() {
      this.getSuggestList();
      this.getColumnList();
      // 未登錄也顯示Banner
      this.getBanners();
    },
    openLogin() {
      this.$parent.$refs.header.handleLogin();
    },
    getBanners() {
      this.$http.get('/banner/list').then(({ data }) => {
        this.bannerList = data;
      });
    },
    // 切换轮播
    swipeChange(method, refName, index) {
      let $swipe = this.$refs[refName];
      if (!$swipe) return;
      if (Array.isArray($swipe)) {
        $swipe = $swipe[index];
      }
      if (!$swipe[method]) return;
      $swipe[method]();
    },
    // 熱評輪播切換
    suggestChange(index) {
      this.suggestSlideIndex = index;
      if (index === this.suggestList.length - 1) {
        this.getSuggestList(index);
      }
    },
    // 熱評陪玩師
    getSuggestList(index) {
      if (this.suggestLoading) return;
      this.suggestLoading = true;
      const pageIndex = this.suggestPageIndex;
      const isFirstPage = pageIndex === 0;
      let excludeUserUuids = this.suggestIds;
      if (isFirstPage) {
        const cacheStr = sessionStorage.getItem('homeSuggestIds');
        if (cacheStr) {
          const cacheAry = cacheStr.split(',');
          if (cacheAry.length) {
            excludeUserUuids = cacheAry;
          }
        }
      }
      this.$http
        .post('/player/skill/recommend', {
          pageIndex,
          pageSize: 20,
          recommendTypes: ['HOT_COMMENT'],
          excludeUserUuids
        })
        .then(({ data }) => {
          const list = data.pageContent.filter(item => {
            const skill = item.playerSkill;
            if (!skill) return false; // 排除髒數據
            if (this.suggestIds.includes(skill.userUuid)) return false; // 前端列表去重
            return true;
          });
          if (!list.length) return;
          this.suggestList.push(
            ...list.reduce((prev, cuur) => {
              const last = prev[prev.length - 1];
              if (last && last.length < 2) {
                last.push(cuur);
                return [...prev];
              } else {
                return [...prev, [cuur]];
              }
            }, [])
          );
          this.suggestInitial = index;
          this.suggestPageIndex++;
          this.suggestLoading = false;
          this.suggestIds.push(...list.map(item => item.playerSkill.userUuid));
          if (isFirstPage) {
            // 初次加載的數據 id 存在本地，這樣可以保證用戶刷新時，每次看到的前幾條熱評都跟上次不同
            sessionStorage.setItem('homeSuggestIds', this.suggestIds.join(','));
          }
        });
    },
    // 排行榜數據
    getRanksList() {
      const getData = rankKind => {
        return new Promise(resolve => {
          this.$http.post('/gift/rank', { rankKind }).then(({ data }) => {
            resolve(
              data.map((item, index) => ({
                ...item,
                rankIndex: index + 1
              }))
            );
          });
        });
      };
      getData('WeeklyReceiveGiftRank').then(list => {
        this.rankListWeek = [list.slice(0, 5), list.slice(5)];
        getData('TotalReceiveGiftRank').then(list => {
          this.rankListTotal = [list.slice(0, 5), list.slice(5)];
        });
      });
    },
    // 獲取遊戲列表
    getColumnList() {
      const getData = async columnId => {
        return new Promise(resolve => {
          const start = Date.now();
          this.$http
            .get('/player/skill/column/skilllist', {
              columnId,
              excludeUuids: this.skillListUids.filter(item => !!item).join(',')
            })
            .then(({ data }) => {
              const len = data.length;
              for (let i = 0; i < 5 - len; i++) {
                data.push({ id: -i });
              }
              const diff = Date.now() - start - 1000;
              if (diff < 0) {
                this.skillTimeout = setTimeout(() => {
                  resolve(data);
                }, -diff);
              } else {
                resolve(data);
              }
            });
        });
      };
      this.$http
        .get('/player/skill/column/columnlist')
        .then(async ({ data }) => {
          let j = 0;
          while (j < data.length) {
            const list = await getData(data[j].id);
            const lists = list.reduce((prev, cuur) => {
              const last = prev[prev.length - 1];
              if (last && last.length < 5) {
                last.push(cuur);
                return [...prev];
              } else {
                return [...prev, [cuur]];
              }
            }, []);
            this.skillListUids.push(
              ...lists[0].map(item => item.userUuid || '')
            );
            const last = lists[lists.length - 1];
            if (last) {
              const more = 5 - last.length;
              if (more > 0) {
                for (let k = 0; k < more; k++) {
                  last.push({
                    id: -k - 1
                  });
                }
              }
            }
            this.skillList.push({
              ...data[j],
              slideIndex: 0,
              lists
            });
            j++;
          }
          this.skillTimeout = 0;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-banner {
  position: relative;
  margin-top: 16px;
}
.link-more {
  display: block;
  background-color: $color-split;
  font-size: 14px;
  font-weight: 500;
  &:hover {
    background-color: #e3e5e9;
  }
}
section {
  margin-top: 48px;
  > .title {
    @include flex(space-between);
    position: relative;
    z-index: 1;
    height: 38px;
    padding-bottom: 8px;
    line-height: 28px;
    color: $color-gray-1;
    font-size: 20px;
    font-weight: 600;
    .link-more {
      @include flex;
      padding: 0 26px;
      height: 30px;
      color: $color-gray-2;
      font-weight: 400;
      border-radius: 22px;
    }
    .rank-switch {
      @include flex;
      height: 100%;
      color: $color-gray-3;
      font-size: 14px;
      font-weight: 400;
      &-buttons {
        @include flex;
        width: 100px;
        height: 28px;
        margin-left: 24px;
        border: 1px solid $color-gray-1;
        border-radius: 4px;
        span {
          flex-grow: 1;
          display: block;
          line-height: 26px;
          text-align: center;
          color: $color-gray-1;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          &.active {
            color: #fff;
            background-color: $color-gray-1;
          }
        }
      }
    }
  }
}
.suggest-slide {
  width: 100%;
  height: 232px;
  &-card {
    @include flex(space-between);
    > div {
      width: 542px;
    }
  }
}
.games-slide {
  position: relative;
  z-index: 0;
  width: 100%;
  margin-top: -30px;
  padding-top: 30px;
  &-card {
    @include flex(space-between);
    > div {
      position: relative;
      background: rgb(249, 249, 249);
      width: 142px;
      height: 100%;
    }
    .cover {
      @include flex;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 0;
      padding-top: 100%;
      border-radius: 4px;
      cursor: pointer;
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
    p {
      @include ellipsis;
      margin-top: 8px;
      color: $color-gray-1;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      text-align: center;
    }
  }
}
.skill-slide {
  position: relative;
  z-index: 0;
  height: 374px;
  margin-top: -40px;
  padding-top: 40px;
  &-card {
    @include flex(space-between, flex-start);
    > div {
      position: relative;
      width: 207px;
      height: 100%;
    }
  }
}
.ranks-slide {
  width: 100%;
  height: 240px;
  margin-top: 24px;
  &-card {
    @include flex(space-between);
    padding-top: 4px;
    > div {
      position: relative;
      width: 208px;
      height: 100%;
      cursor: pointer;
    }
    .rank-item-card {
      @include flex(flex-start, center, column);
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;
      border-radius: 9px;
      > * {
        position: relative;
      }
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      &::before {
        background: linear-gradient(180deg, #e8eaee 0%, #d2d5dc 100%);
      }
      &.rank {
        &-a,
        &-b,
        &-c {
          background-image: url('~@/assets/image/background/home-rank-card.png');
          background-size: 100% 100%;
        }
        &-a {
          &::before {
            background: linear-gradient(
              180deg,
              rgba(255, 228, 87, 0.85) 0%,
              rgba(255, 192, 0, 0.85) 100%
            );
          }
        }
        &-b {
          &::before {
            background: linear-gradient(
              180deg,
              rgba(169, 240, 255, 0.85) 0%,
              rgba(91, 190, 255, 0.85) 100%
            );
          }
        }
        &-c {
          &::before {
            background: linear-gradient(
              180deg,
              rgba(255, 215, 113, 0.85) 0%,
              rgba(255, 152, 58, 0.85) 100%
            );
          }
        }
      }
      .rank-avatar {
        width: 104px;
        height: 104px;
        margin-top: 26px;
        padding: 4px;
        background-color: rgba($color: #fff, $alpha: 0.6);
        border-radius: 100%;
      }
      p {
        @include ellipsis;
        max-width: 154px;
        margin-top: 20px;
        line-height: 20px;
        color: $color-gray-1;
        font-size: 14px;
        font-weight: 600;
      }
      .rank-value {
        @include flex;
        margin-top: 12px;
        padding: 0 7px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        background-color: rgba($color: $color-gray-1, $alpha: 0.2);
        color: #fff;
        font-size: 12px;
        .icon {
          margin: 0 1px 0 5px;
        }
      }
    }
    .rank-item-number {
      @include flex;
      position: absolute;
      z-index: 1;
      left: 12px;
      top: -4px;
      width: 82px;
      height: 84px;
      padding: 0 10px 8px 16px;
      color: $color-gray-3;
      font-size: 26px;
      font-weight: 700;
      font-style: italic;
      letter-spacing: -0.272px;
      transform: scale(0.5);
      transform-origin: 0 0;
      &.rank-item-flag {
        background-image: url('~@/assets/image/background/home-rank-flag.png');
        background-size: 100% 100%;
        color: #fff;
      }
    }
  }
}
.bottom-blank {
  height: 130px;
}

@media screen and (max-width: 599px) {
  .custom-swiper {
    .custom-arrow {
      display: none;
    }
  }
  .home-banner {
    position: relative;
    width: 100%;
    height: 90px;
    margin: 0;
  }
  section {
    margin-top: 12px;
    padding: 0 16px;
    > .title {
      font-size: 16px;
      height: 34px;
      .link-more {
        padding: 0 8px;
        height: 22px;
        font-size: 12px;
      }
    }
  }
  .suggest-slide {
    height: 132px;
    /deep/ & > div {
      @include flex(flex-start);
      overflow-x: auto;
    }
    &-card {
      flex-shrink: 0;
      position: relative;
      width: auto;
      transform: translateX(0) !important;
      & + .suggest-slide-card {
        margin-left: 8px;
      }
    }
  }
  .games-slide {
    padding-top: 38px;
    &-card {
      overflow-x: auto;
      > div {
        flex-shrink: 0;
        width: 80px;
        + div {
          margin-left: 8px;
        }
      }
      p {
        font-size: 12px;
        line-height: 14px;
      }
    }
  }
  .skill-panel {
    @include flex(flex-start);
    flex-wrap: wrap;
    margin: 0 -4px;
    padding: 4px 0;
    > div {
      margin: 4px;
      width: calc(50% - 8px);
    }
  }
  .bottom-blank {
    height: 20px;
  }
}
</style>
